export default "__VITE_ASSET__CSJsz4xJ__"